// import React from "react";
// import { Upload, Button } from "antd";
// import { Controller, useFormContext } from "react-hook-form";
// import { UploadOutlined } from "@ant-design/icons";
// import { axiosPrivate } from "config/Api";

// const UploadField = ({ name, fieldType, label, ocfDisplayId }) => {
//   const { control } = useFormContext();
//   return (
//     <Controller
//       name={name}
//       control={control}
//       render={({ field }) => (
//         <Upload
//           maxCount={1}
//           beforeUpload={async (file) => {
//             const fd = new FormData();
//             fd.append("file", file);
//             fd.append(
//               "data",
//               JSON.stringify({
//                 ocfDisplayId,
//                 fieldType,
//                 fileName: file.name,
//               })
//             );
//             const res = await axiosPrivate.post("/om/uploadFile", fd);
//             field.onChange(res.data);
//             return false;
//           }}
//           onRemove={async () => {
//             console.log("delete");
//             console.log("field.value?.id", field?.value);
//             if (field.value?.message) {
//               const params = {
//                 folder: "123456789",
//                 fileName: field?.value?.message,
//               };
//               const options = {
//                 url: "/om/delete",
//                 method: "delete",
//                 params,
//               };
//               console.log(options);
//               await axiosPrivate(options);
//             }
//             field.onChange(null);
//           }}
//         >
//           <Button icon={<UploadOutlined />}>{label}</Button>
//         </Upload>
//       )}
//     />
//   );
// };

// export default UploadField;

// import React from "react";
// import { Upload, Button } from "antd";
// import { Controller, useFormContext } from "react-hook-form";
// import { UploadOutlined } from "@ant-design/icons";
// import { axiosPrivate } from "config/Api";

// const UploadField = ({ name, fieldType, label, ocfDisplayId }) => {
//   const { control } = useFormContext();

//   return (
//     <Controller
//       name={name}
//       control={control}
//       render={({ field }) => {
//         // 🔥 convert existing value to AntD fileList
//         const fileList = field.value?.message
//           ? [
//               {
//                 uid: "-1",
//                 name: field.value.message,
//                 status: "done",
//               },
//             ]
//           : [];

//         return (
//           <Upload
//             maxCount={1}
//             fileList={fileList} // ⭐ important
//             beforeUpload={async (file) => {
//               const fd = new FormData();
//               fd.append("file", file);
//               fd.append(
//                 "data",
//                 JSON.stringify({
//                   ocfDisplayId,
//                   fieldType,
//                   fileName: file.name,
//                 })
//               );

//               const res = await axiosPrivate.post("/om/uploadFile", fd);

//               field.onChange(res.data); // store server response
//               return false;
//             }}
//             onRemove={async () => {
//               if (field.value?.message) {
//                 await axiosPrivate.delete("/om/delete", {
//                   params: {
//                     folder: ocfDisplayId,
//                     fileName: field.value.message,
//                   },
//                 });
//               }

//               field.onChange(null);
//             }}
//           >
//             <Button icon={<UploadOutlined />}>{label}</Button>
//           </Upload>
//         );
//       }}
//     />
//   );
// };

// export default UploadField;

import React, { useState } from "react";
import { Upload, Button, message, ConfigProvider } from "antd";
import { Controller, useFormContext } from "react-hook-form";
import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { axiosPrivate } from "config/Api";
import { showNotification } from "service/Notification";

const UploadField = ({ name, fieldType, label, ocfDisplayId }) => {
  const { control } = useFormContext();
  const handleView = async (fileName) => {
    try {
      setDownloading(true);
      const response = await axiosPrivate.get("/om/public/download", {
        params: {
          ocfDisplayId,
          documentId: fileName,
        },
        responseType: "blob", // IMPORTANT
      });

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName; // 👈 file name
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      message.error("Unable to download file");
    } finally {
      setDownloading(false);
    }
  };
  const [uploading, setUploading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const existingFile = field.value?.message;

        // ONLY for display
        const displayName = existingFile?.slice(25) || existingFile;

        const fileList = existingFile
          ? [
              {
                uid: "-1",
                name: displayName,
                status: "done",
              },
            ]
          : [];

        return (
          // <Upload
          //   maxCount={1}
          //   fileList={fileList}
          //   showUploadList={{
          //     showRemoveIcon: true,
          //   }}
          //   /* ✅ BLOCK NEW UPLOAD IF FILE EXISTS */
          //   beforeUpload={async (file) => {
          //     if (existingFile) {
          //       message.warning("Delete existing file before uploading new one");
          //       return Upload.LIST_IGNORE; // 🚀 stops upload completely
          //     }
          //     try{

          //     }
          //     const fd = new FormData();
          //     fd.append("file", file);
          //     fd.append(
          //       "data",
          //       JSON.stringify({
          //         ocfDisplayId,
          //         fieldType,
          //         fileName: file.name,
          //       })
          //     );

          //     const res = await axiosPrivate.post("/om/uploadFile", fd);
          //     if (res?.data?.status === "200") {
          //     }
          //     field.onChange(res.data);

          //     return false;
          //   }}
          //   /* ✅ DELETE */
          //   onRemove={async () => {
          //     if (existingFile) {
          //       await axiosPrivate.delete("/om/delete", {
          //         params: {
          //           folder: ocfDisplayId,
          //           fileName: existingFile,
          //         },
          //       });
          //     }

          //     field.onChange(null);
          //   }}
          //   style={{ margin: "10px 0px" }}
          // >
          //   {/* 🔥 Button disabled when file exists */}
          //   <Button icon={<UploadOutlined />} disabled={!!existingFile}>
          //     {existingFile ? "Document Uploaded" : label}
          //   </Button>
          //   {existingFile && (
          //     <ConfigProvider componentDisabled={false}>
          //       <Button
          //         type="link"
          //         icon={<EyeOutlined />}
          //         onClick={() => handleView(existingFile)}
          //         loading={downloading}
          //       >
          //         {downloading ? "Downloading..." : "View File"}
          //       </Button>
          //     </ConfigProvider>
          //   )}
          // </Upload>

          <Upload
            maxCount={1}
            fileList={fileList}
            showUploadList={{ showRemoveIcon: true }}
            beforeUpload={async (file) => {
              if (existingFile) {
                message.warning("Delete existing file before uploading new one");
                return Upload.LIST_IGNORE;
              }

              try {
                setUploading(true);

                const fd = new FormData();
                fd.append("file", file);
                fd.append(
                  "data",
                  JSON.stringify({
                    ocfDisplayId,
                    fieldType,
                    fileName: file.name,
                  })
                );

                const res = await axiosPrivate.post("/om/uploadFileForOcf", fd);
                field.onChange(res.data);
              } catch (error) {
                console.log(error);
                message.error(error?.response?.data?.message);
                showNotification(error?.response?.message || "Failed to upload.");
              } finally {
                setUploading(false);
              }

              return false;
            }}
            onRemove={async () => {
              try {
                setUploading(true);

                if (existingFile) {
                  await axiosPrivate.delete("/om/delete", {
                    params: {
                      folder: ocfDisplayId,
                      fileName: existingFile,
                    },
                  });
                }

                field.onChange(null);
              } catch (error) {
                message.error("Delete failed");
                showNotification(error?.response?.message || "Failed to delete.");
              } finally {
                setUploading(false);
              }
            }}
            style={{ margin: "10px 0px" }}
          >
            <Button
              icon={<UploadOutlined />}
              disabled={!!existingFile || uploading}
              loading={uploading}
            >
              {uploading ? "Uploading..." : existingFile ? "Document Uploaded" : label}
            </Button>

            {existingFile && (
              <ConfigProvider componentDisabled={false}>
                <Button
                  type="link"
                  icon={<EyeOutlined />}
                  onClick={() => handleView(existingFile)}
                  loading={downloading}
                >
                  {downloading ? "Downloading..." : "View File"}
                </Button>
              </ConfigProvider>
            )}
          </Upload>
        );
      }}
    />
  );
};

export default UploadField;
